import { Component, OnInit, Input, ViewChild, SimpleChanges } from "@angular/core";
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, map, tap, takeUntil } from "rxjs/operators";
import { CampaignsService } from "src/app/pages/campaign-module/campaigns/campaigns.service";
import { MatChipList } from "@angular/material/chips";
import { MatAutocomplete, MatAutocompleteTrigger } from "@angular/material/autocomplete";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { DialogService, LanguageService, HelperService } from "src/app/services";
import { of as observableOf, Subscription, fromEvent } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PATTERN_NUMERIC } from "src/app/utils/constant";
import { MediaObserver } from "@angular/flex-layout";
import * as moment from "moment";
import * as _ from "lodash";
 
@Component({
  selector: "esc-step-two",
  templateUrl: "./step-two.component.html",
  styleUrls: ["./step-two.component.scss"]
})
export class StepTwoComponent implements OnInit {
  @Input() campaignData;
  @Input() distributionData;
  @Input() loadingDistribution;
  @Input() viewMode;
  @Input() editMode;
  @Input() status;
  @Input() did_generate;
  @Input() campaignDataFromList;
  @ViewChild('chipsCategory') chipsCategory: MatChipList;
  @ViewChild('chipsBrand') chipsBrand: MatChipList;
  @ViewChild('chipsItem') chipsItem: MatChipList;
  @ViewChild('chipsRegion') chipsRegion: MatChipList;
  @ViewChild('chipsProvince') chipsProvince: MatChipList;
  @ViewChild('chipsCity') chipsCity: MatChipList;
  @ViewChild('chipsChainType') chipsChainType: MatChipList;
  @ViewChild('chipsChain') chipsChain: MatChipList;
  @ViewChild('chipsBranch') chipsBranch: MatChipList;
  @ViewChild('chipsWebUser') chipsWebUser: MatChipList;
  @ViewChild('chipsRecipient') chipsRecipient: MatChipList;

  @ViewChild('categoryAC') categoryACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) categoryACTr: MatAutocompleteTrigger;
  @ViewChild('brandAC') brandACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) brandACTr: MatAutocompleteTrigger;
  @ViewChild('itemAC') itemACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) itemACTr: MatAutocompleteTrigger;
  @ViewChild('location_regionAC') regionACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) regionACTr: MatAutocompleteTrigger;
  @ViewChild('location_provinceAC') provinceACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) provinceACTr: MatAutocompleteTrigger;
  @ViewChild('location_cityAC') cityACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) cityACTr: MatAutocompleteTrigger;
  @ViewChild('chain_typeAC') chain_typeACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) chain_typeACTr: MatAutocompleteTrigger;
  @ViewChild('chainAC') chainACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) chainACTr: MatAutocompleteTrigger;
  @ViewChild('branchAC') branchACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) branchACTr: MatAutocompleteTrigger;
  @ViewChild('web_userAC') web_userACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) web_userACTr: MatAutocompleteTrigger;
  @ViewChild('recipientAC') recipientACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) recipientACTr: MatAutocompleteTrigger;
 
  public minDate;
  public maxDate;
  public minExpiryDate;
  public maxExpiryDate;
  public loading = {
    category: false,
    brand: false,
    item: false,
    location_region: false,
    location_province: false,
    location_city: false,
    chain_type: false,
    chain: false,
    branch: false,
    web_user: false,
    recipient: false,
    error: false
  };
  public defaultOption = {
    id: 0,
    code: "all",
    description: "All",
    selected: false
  };
  private actTypeSub: Subscription;
  public filters;
  public formGroup: FormGroup;
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});
  public savedMultiSelect = {
    selectedCategories: [],
    selectedBrands: [],
    selectedItems: [],
    selectedRegions: [],
    selectedProvinces: [],
    selectedCities: [],
    selectedChainTypes: [],
    selectedChains: [],
    selectedBranch: [],
    selectedWebUser: [],
    selectedRecipient: []
  }

  constructor(
    private fb: FormBuilder,
    public helper: HelperService,
    public media: MediaObserver,
    public campSvc: CampaignsService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    ){}
 
  ngOnInit() {
    this.filters = _.cloneDeep(INITIAL_OPTIONS);
    this.initForm();
    this.detectFormChanges();
  }
 
  catBrandItem = [
    {
      code: "0",
      description: "Category"
    },
    {
      code: "1",
      description: "Brand"
    },
    {
      code: "2",
      description: "Item"
    }
  ];

  couponGenerationType = [
    { id: 1, code: "PG", description: "Pre-Generated"},
    { id: 2, code: "OD", description: "On Demand"},
    // { id: 3, code: "single_coupon", description: "Single Coupon"},
  ]

 
  categorys = [];
  brands = [];
  items = [];
  location_regions = [];
  location_provinces = [];
  location_citys = [];
  chain_types = [];
  chains = [];
  branches = [];
  web_users = [];
  recipients = [];
   
  expTypes = [
    {
      code: "0",
      description: "Defined Date"
    },
    {
      code: "1",
      description: "One Time Use"
    },
    {
      code: "2",
      description: "No. of days without transaction"
    },
    {
      code: "3",
      description: "No. of days from first purchased date"
    }
  ];
 
  actTypes = [
    { code: "0", description: "Activated" },
    { code: "1", description: "Required Registration (by Date)" },
    { code: "2", description: "Required Registration" }
  ];

  multiSelect = {
    selectedCategories: [],
    selectedBrands: [],
    selectedItems: [],
    selectedRegions: [],
    selectedProvinces: [],
    selectedCities: [],
    selectedChainTypes: [],
    selectedChains: [],
    selectedBranch: [],
    selectedWebUser: [],
    selectedRecipient: []
  };
 
  resetActTypes() {
    this.actTypes = [
      { code: "0", description: "Activated" },
      { code: "1", description: "Required Registration (by Date)" },
      { code: "2", description: "Required Registration" }
    ];
  }

  initForm() {
    this.formGroup = this.fb.group({
      code: null,
      description: [null,[Validators.required, Validators.maxLength(250)]],
      redemption_printout_message: [null, [Validators.maxLength(255)]],
      reversal_printout_message: [null, [Validators.maxLength(255)]],
      show_groups_in_reports: [false],
      red_start_date: [null, Validators.required],
      red_end_date: [null, Validators.required],
      generation_type: [null, Validators.required],
      pre_generated_qty: [null, [Validators.required, Validators.max(3000000), Validators.pattern(PATTERN_NUMERIC), Validators.min(1)]],
      cat_brand_item: [null, Validators.required],
      category: [[0], this.helper.chipsRequiredValidator],
      brand: [[0], this.helper.chipsRequiredValidator],
      item: [[0], this.helper.chipsRequiredValidator],
      web_user: [[0], this.helper.chipsRequiredValidator],
      recipient: [[0], this.helper.chipsRequiredValidator],
      location_country: [0],
      location_region: [[0], this.helper.chipsRequiredValidator],
      location_province: [[0], this.helper.chipsRequiredValidator],
      location_city: [[0], this.helper.chipsRequiredValidator],
      chain_type: [[0], this.helper.chipsRequiredValidator],
      chain: [[0], this.helper.chipsRequiredValidator],
      branch: [[0], this.helper.chipsRequiredValidator],
      act_type: [null, Validators.required],
      reg_deadline: [null, Validators.required],
      num_of_txn: [null, [Validators.required, Validators.pattern(PATTERN_NUMERIC), Validators.min(0)]],
      exp_type: ["0", Validators.required],
      exp_date: [null, Validators.required],
      generate_active_coupon: [true, [Validators.required]],
      num_of_days: [null, [Validators.required, Validators.pattern(PATTERN_NUMERIC), Validators.min(1)]],
      num_of_days_from_first_purchase: [null, [Validators.required, Validators.pattern(PATTERN_NUMERIC),Validators.min(1)]],
      is_cancelled: [false],
    });
 
    this.formGroup.get('code').disable();
    this.formGroup.get('generate_active_coupon').disable();

    if(this.viewMode) {
      this.formGroup.disable();
    }

    if(this.status != "new"){
      this.formGroup.get('code').setValue(this.campaignDataFromList["distribution_code"])
    }

    this.multiSelect.selectedRegions = [this.defaultOption]
    this.multiSelect.selectedProvinces = [this.defaultOption]
    this.multiSelect.selectedCities = [this.defaultOption]
    this.multiSelect.selectedChainTypes = [this.defaultOption]
    this.multiSelect.selectedChains = [this.defaultOption]
    this.multiSelect.selectedBranch = [this.defaultOption]
  }
  
  areChipsRemovable(name, data) {
    if (_.find(this.savedMultiSelect[name], val => val.id == data.id)) {
      return false
    } 
    return true
  }

  ngOnChanges(changes: SimpleChanges) {
    // Get distribution data if exists
    const currentValue: any = _.get(changes, 'distributionData.currentValue')

    // Set distribution dates to campaign dates
    const campaign_start_date_raw = _.get(this.campaignData, 'start_date');
    const campaign_end_date_raw = _.get(this.campaignData, 'end_date');
    const campaign_start_date = moment(campaign_start_date_raw).toDate();
    const campaign_end_date = moment(campaign_end_date_raw).toDate();
    const distribution_start_date = moment(_.get(currentValue, 'start_date')).toDate();
    const distribution_end_date = moment(_.get(currentValue, 'end_date')).toDate();

    // Set min and max dates based on campaign dates
    if (this.campaignData) {
      this.minDate = campaign_start_date;
      this.maxDate = campaign_end_date;
    } else {
      this.minDate = moment().add(1, 'd').toDate()
      this.maxDate = null
    }

    this.minExpiryDate = moment(this.minDate).add(1, 'd').toDate();
    this.maxExpiryDate = moment(this.maxDate).add(1, 'd').toDate();

    if(changes.distributionData && currentValue) {
      this.disableFields();

      this.formGroup.patchValue({
        description: _.get(currentValue, 'description'),
        redemption_printout_message: _.get(currentValue, 'redemption_printout_message'),
        reversal_printout_message: _.get(currentValue, 'reversal_printout_message'),
        cat_brand_item: _.get(currentValue, 'distribution_sku_mode') == "SKU" ? this.catBrandItem[2] : _.get(currentValue, 'distribution_sku_mode') == "CATEGORY" ? this.catBrandItem[0] : this.catBrandItem[1],
        generation_type: _.get(currentValue, 'generation_type') == "PG" ? this.couponGenerationType[0] : this.couponGenerationType[1],
        pre_generated_qty: _.get(currentValue, 'pre_generated_quantity'),
        red_start_date: campaign_start_date,
        red_end_date: campaign_end_date,
        category: this.getMultiSelectValue(_.get(currentValue, 'categories'), 'id'),
        brand: this.getMultiSelectValue(_.get(currentValue, 'brands'), 'id'),
        item: this.getMultiSelectValue(_.get(currentValue, 'skus'), 'id'),
        act_type: _.get(currentValue, 'is_initially_registered') == 1 ? "0" : _.get(currentValue, 'unregistered_allowed_usable_date') != null ? "1" : "2",
        reg_deadline: _.get(currentValue, 'unregistered_allowed_usable_date') ? new Date(_.get(currentValue, 'unregistered_allowed_usable_date')) : null,
        num_of_txn: _.get(currentValue, 'unregistered_allowed_usage_count'),
        exp_type: _.get(currentValue, 'expiry_max_usage_count') == 1 ? "1" : _.get(currentValue, 'expiry_date') != null ? "0" : _.get(currentValue, 'expiry_max_days_from_first_purchase') ? "3" : "2",
        exp_date: _.get(currentValue, 'expiry_date') ? new Date(_.get(currentValue, 'expiry_date')) : null,
        num_of_days: _.get(currentValue, 'expiry_max_days_without_txn'),
        num_of_days_from_first_purchase: _.get(currentValue, 'expiry_max_days_from_first_purchase'),
        is_cancelled: _.get(currentValue, 'is_cancelled'),
        chain_type: this.getMultiSelectValue(_.get(currentValue, 'chain_type_ids'), 'id'),
        chain: this.getMultiSelectValue(_.get(currentValue, 'chain_ids'), 'id'),
        branch: this.getMultiSelectValue(_.get(currentValue, 'branch_ids'), 'id'),
        location_country: this.getMultiSelectValue(_.get(currentValue, 'countries')),
        location_region: this.getMultiSelectValue(_.get(currentValue, 'regions')),
        location_province: this.getMultiSelectValue(_.get(currentValue, 'provinces')),
        location_city: this.getMultiSelectValue(_.get(currentValue, 'cities')),
        web_user: this.getMultiSelectValue(_.get(currentValue, 'user_group_ids'), 'id'),
        recipient: this.getMultiSelectValue(_.get(currentValue, 'recipient_group_ids'), 'id'),
        show_groups_in_reports: _.get(currentValue, 'show_groups_in_reports') == 1 ? true : false,
        generate_active_coupon: _.get(currentValue, 'generate_active_coupon') == 1 ? true : false
      })
 
      const multiSelectValues = {
        selectedCategories: this.getMultiSelectValue(_.get(currentValue, 'categories')), 
        selectedBrands: this.getMultiSelectValue(_.get(currentValue, 'brands')),
        selectedItems: this.getMultiSelectValue(_.get(currentValue, 'skus')),
        selectedRegions: this.getMultiSelectValue(_.get(currentValue, 'regions')),
        selectedProvinces: this.getMultiSelectValue(_.get(currentValue, 'provinces')), 
        selectedCities: this.getMultiSelectValue(_.get(currentValue, 'cities')),
        selectedChainTypes: this.getMultiSelectValue(_.get(currentValue, 'chain_types')), 
        selectedChains: this.getMultiSelectValue(_.get(currentValue, 'chain_ids')),
        selectedBranch: this.getMultiSelectValue(_.get(currentValue, 'branch_ids')),
        selectedRecipient: this.getMultiSelectValue(_.get(currentValue, 'recipient_group_ids')),
        selectedWebUser: this.getMultiSelectValue(_.get(currentValue, 'user_group_ids'))
      }

      this.multiSelect = _.cloneDeep(multiSelectValues)

      if (_.toLower(this.status) == 'ongoing' || this.did_generate == 1) {
        this.savedMultiSelect.selectedRecipient = _.cloneDeep(multiSelectValues.selectedRecipient)
        this.savedMultiSelect.selectedWebUser = _.cloneDeep(multiSelectValues.selectedWebUser)
      }
      console.log('this.savedMultiSelect',this.savedMultiSelect)

      this.categorys = this.getMultiSelectValue(_.get(currentValue, 'categories'))
      this.brands = this.getMultiSelectValue(_.get(currentValue, 'brands'))
      this.items = this.getMultiSelectValue(_.get(currentValue, 'skus'))
      this.location_regions = this.getMultiSelectValue(_.get(currentValue, 'regions'))
      this.location_provinces = this.getMultiSelectValue(_.get(currentValue, 'provinces'))
      this.location_citys = this.getMultiSelectValue(_.get(currentValue, 'cities'))
      this.chain_types = this.getMultiSelectValue(_.get(currentValue, 'chain_types'))
      this.chains = this.getMultiSelectValue(_.get(currentValue, 'chain_ids'))
      this.branches = this.getMultiSelectValue(_.get(currentValue, 'branch_ids'))
      this.web_users = this.getMultiSelectValue(_.get(currentValue, 'user_group_ids'))
      this.recipients = this.getMultiSelectValue(_.get(currentValue, 'recipient_group_ids'))

      if(_.get(currentValue, 'is_cancelled')){
        this.formGroup.disable();
      }

    } else if (_.toLower(this.status) == "new" && this.formGroup) { 
      // REWARDS-1159 Handling
      // here is if the campaign new, calling `insertCampaign` in campaign-wizard
      // and setting the campaignData there will trigger this lifecycle listener
      // Once that happens, it will clear all multi-selects including web-user and recipient controls,
      // If the user is on step three and went back to step two, the multi-select values will default to default options
      const changeFromStepValidate = changes.campaignData && changes.campaignData.previousValue !== undefined
      //clear form values
      if (!changeFromStepValidate) {
        for (const key in this.multiSelect) {
          this.multiSelect[key] = [this.defaultOption];
        }
      }

      this.disableFields();
      // this.activationTypeToggle(this.formGroup.get('act_type').value);
      this.expirationTypeToggle(this.formGroup.get('exp_type').value);

      this.onGenerationTypeChange(this.formGroup.get('generation_type').value);

      // Set start and end date from campaign
      this.formGroup.controls['red_start_date'].setValue(campaign_start_date);
      this.formGroup.controls['red_end_date'].setValue(campaign_end_date);
      this.formGroup.controls['exp_date'].setValue(campaign_end_date);
    }
  }

  disableFields() {

    if (_.toLower(this.status) == "new" && !this.viewMode) {
      this.formGroup.enable({emitEvent:false});
      this.formGroup.get('code').disable({emitEvent:false});
      this.formGroup.get('red_start_date').disable({emitEvent:false});
      this.formGroup.get('red_end_date').disable({emitEvent:false});
      this.formGroup.get('num_of_txn').disable({emitEvent:false});
      this.formGroup.get('reg_deadline').disable({emitEvent:false});
    } else if (_.toLower(this.status) == "pending" && (this.did_generate == false) && this.editMode) {
      this.formGroup.enable({emitEvent:false});
      this.formGroup.get('code').disable({emitEvent:false});
      this.formGroup.get('red_start_date').disable({emitEvent:false});
      this.formGroup.get('red_end_date').disable({emitEvent:false});
      this.formGroup.get('num_of_txn').disable({emitEvent:false});
      this.formGroup.get('reg_deadline').disable({emitEvent:false});
    } else if (_.toLower(this.status) == "pending" && (this.did_generate == true) && this.editMode) {
      this.formGroup.disable({emitEvent:false});
      this.formGroup.get('description').enable({emitEvent:false});
      this.formGroup.get('redemption_printout_message').enable({emitEvent:false});
      this.formGroup.get('reversal_printout_message').enable({emitEvent:false});
      this.formGroup.get('item').enable({emitEvent:false});
      this.formGroup.get('exp_date').enable({emitEvent:false});
      this.formGroup.get('web_user').enable({emitEvent:false});
      this.formGroup.get('recipient').enable({emitEvent:false});
      this.formGroup.get('show_groups_in_reports').enable({emitEvent:false});
    } else if (_.toLower(this.status) == "ongoing" && this.editMode) {
      this.formGroup.disable({emitEvent:false});
      this.formGroup.get('description').enable({emitEvent:false});
      this.formGroup.get('redemption_printout_message').enable({emitEvent:false});
      this.formGroup.get('redemption_printout_message').enable({emitEvent:false});
      this.formGroup.get('reversal_printout_message').enable({emitEvent:false});
      this.formGroup.get('item').enable({emitEvent:false});
      this.formGroup.get('exp_date').enable({emitEvent:false});
      this.formGroup.get('web_user').enable({emitEvent:false});
      this.formGroup.get('recipient').enable({emitEvent:false});
      this.formGroup.get('show_groups_in_reports').enable({emitEvent:false});
    } else if (this.viewMode) {
      this.formGroup.disable({emitEvent:false});
    }

    this.formGroup.get('generate_active_coupon').disable({emitEvent:false});
    
  }

  getMultiSelectValue(value, key=null) {
    let selectedValue: any[];
    if (key) {
      selectedValue = [0]
      if (value && _.size(value) && value != 0) {
        selectedValue = value.map(val => val[key])
      }
    } else {
      selectedValue = [this.defaultOption]
      if (value && _.size(value) && value != 0) {
        selectedValue = value.map(val => ({...val, selected: true}))
      }
    }
    return selectedValue
  }

  detectFormChanges() {
    this.formGroup.get("cat_brand_item").valueChanges.subscribe(value => {
      this.categoryBrandItemToggle(value);
    });
 
    this.formGroup.get("category").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.categorys = [];
      this.getData("category");
    });
 
    this.formGroup.get("brand").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.brands = [];
      this.getData("brand");
    });
 
    this.formGroup.get("item").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.items = [];
      this.getData("item");
    });
 
    this.formGroup.get("location_region").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.location_regions = [];

      if(value) {
        this.location_provinces = [];
        this.multiSelect.selectedProvinces.splice(0, this.multiSelect.selectedProvinces.length);
  
        this.location_citys = [];
        this.multiSelect.selectedCities.splice(0, this.multiSelect.selectedCities.length);
      }
      this.getData("location_region");
    });
 
    this.formGroup.get("location_province").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.location_provinces = [];
      this.getData("location_province");
    });
 
    this.formGroup.get("location_city").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.location_citys = [];
      this.getData("location_city");
    });
 
    this.formGroup.get("chain_type").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.chain_types = [];
      this.getData("chain_type");
    });
 
    this.formGroup.get("chain").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.chains = [];
      this.getData("chain");
    });
 
    this.formGroup.get("branch").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.branches = [];
      this.getData("branch");
    });
 
    this.formGroup.get("location_region").statusChanges.subscribe(
      status => {
        if(this.multiSelect.selectedRegions.length && (!this.formGroup.get("location_region").valid)) {
          this.formGroup.get("location_region").markAsUntouched();
          return;
        }
        if(this.chipsRegion) {
          this.chipsRegion.errorState = status === 'INVALID'
        }
      }
    );
 
    this.formGroup.get("location_province").statusChanges.subscribe(
      status => {
        if(this.multiSelect.selectedProvinces.length && (!this.formGroup.get("location_province").valid)) {
          this.formGroup.get("location_province").markAsUntouched();
          return;
        }
        if(this.chipsProvince) {
          this.chipsProvince.errorState = status === 'INVALID'
        }
      }
    );
 
    this.formGroup.get("location_city").statusChanges.subscribe(
      status => {
        if(this.multiSelect.selectedCities.length && (!this.formGroup.get("location_city").valid)) {
          this.formGroup.get("location_city").markAsUntouched();
          return;
        }
        if(this.chipsCity) {
          this.chipsCity.errorState = status === 'INVALID'
        }
      }
    );
 
    this.formGroup.get("chain_type").statusChanges.subscribe(
      status => {
        if(this.multiSelect.selectedChainTypes.length && (!this.formGroup.get("chain_type").valid)) {
          this.formGroup.get("chain_type").markAsUntouched();
          return;
        }
        if(this.chipsChainType) {
          this.chipsChainType.errorState = status === 'INVALID'
        }
      }
    );
 
    this.formGroup.get("chain").statusChanges.subscribe(
      status => {
        if(this.multiSelect.selectedChains.length && (!this.formGroup.get("chain").valid)) {
          this.formGroup.get("chain").markAsUntouched();
          return;
        }
        if(this.chipsChain) {
          this.chipsChain.errorState = status === 'INVALID'
        }
      }
    );
 
    this.formGroup.get("branch").statusChanges.subscribe(
      status => {
        if(this.multiSelect.selectedBranch.length && (!this.formGroup.get("branch").valid)) {
          this.formGroup.get("branch").markAsUntouched();
          return;
        }
        if(this.chipsBranch) {
          this.chipsBranch.errorState = status === 'INVALID'
        }
      }
    );
 
    this.formGroup.get("web_user").statusChanges.subscribe(
      status => {
        if(this.multiSelect.selectedWebUser.length && (!this.formGroup.get("web_user").valid)) {
          this.formGroup.get("web_user").markAsUntouched();
          return;
        }
        if(this.chipsWebUser) {
          this.chipsWebUser.errorState = status === 'INVALID'
        }
      }
    );

    this.formGroup.get("recipient").statusChanges.subscribe(
      status => {
        if(this.multiSelect.selectedRecipient.length && (!this.formGroup.get("recipient").valid)) {
          this.formGroup.get("recipient").markAsUntouched();
          return;
        }
        if(this.chipsRecipient) {
          this.chipsRecipient.errorState = status === 'INVALID'
        }
      }
    );
    
    this.actTypeSub = this.formGroup.get("act_type").valueChanges.subscribe(value => {
      if(this.viewMode) {
        if(this.actTypeSub && !this.actTypeSub.closed) {
          this.actTypeSub.unsubscribe();
        }
        this.formGroup.disable();
        return;
      }
      // this.activationTypeToggle(value);
    });
 
    this.formGroup.get("exp_type").valueChanges.subscribe(value => {
      this.expirationTypeToggle(value);
    });

    this.formGroup.get("web_user").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.web_users = [];
      this.getData("web_user");
    });

    this.formGroup.get("recipient").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.recipients = [];
      this.getData("recipient");
    });

    this.formGroup.get("generation_type").valueChanges.pipe(
      debounceTime(600),
      filter((term) => _.isObject(term)),
    )
    .subscribe(value => {
      this.onGenerationTypeChange(value);
    });
  }
 
  onGenerationTypeChange(value) {
    if (!value || _.toLower(this.status) == 'ongoing' || this.did_generate == 1 || this.viewMode) {
      return;
    }

    if (value["code"] == 'PG') {
      this.formGroup.get('pre_generated_qty').enable({emitEvent: false})

      // Bring back "Activated" option if it was removed
      this.resetActTypes();
    } else {
      this.formGroup.get('pre_generated_qty').disable({emitEvent: false})
      
      // Reset Activation fields if "Activated" option (value == 0) is currently set
      if (this.formGroup.get("act_type").value == 0) {
        this.formGroup.get("act_type").reset();
        // this.formGroup.get("reg_deadline").reset();
        // this.formGroup.get("num_of_txn").reset();
      }

      // Remove "Activated" option if on demand generation_type is selected
      this.actTypes = this.actTypes.filter(a => a.code !== "0");
    }
  }

  getInitialData(name) {
    this.autoCmpltClosed(name);
    this.filters = _.cloneDeep(INITIAL_OPTIONS);
    this.getData(name);
  }
 
  getMoreData(name) {
    if (this.filters.getMore) {
      this.filters.web_filter.offset += INITIAL_OPTIONS.web_filter.limit;
      this.getData(name);
    }
  }
 
  getData(name) {
    let filters = _.cloneDeep(this.filters)
    this.filters.getMore = false;
    this.loading[name] = true;
 
    switch (name) {
      case "category": {
        this.campSvc.getWizardCategories(filters).pipe(
          tap(() => this.loading.category = true),
          finalize(() => {
            this.loading.category = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.category = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.category = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
              this.loading.error = true;
              this.categorys = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.categorys[0] = this.defaultOption;
              }
              this.categorys = this.categorys.concat(res.data);
              this.checkSelected('categorys', 'selectedCategories', 'category');

              if((res.data.length > 0) && (this.categorys.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }
      
      case "brand": {
        filters.web_filter["category_ids"] = this.multiSelect.selectedCategories.length ? this.multiSelect.selectedCategories.map(e => { return e.id }) : [0];
        filters.web_filter["brand_ids"] = [0];
 
        this.campSvc.getWizardBrands(filters).pipe(
          tap(() => this.loading.brand = true),
          finalize(() => {
            this.loading.brand = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.brand = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.brand = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
              this.loading.error = true;
              this.brands = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.brands[0] = this.defaultOption;
              }
              this.brands = this.brands.concat(res.data);
              this.checkSelected('brands', 'selectedBrands', 'brand');

              if((res.data.length > 0) && (this.brands.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }
      
      case "item": {
        filters.web_filter["category_ids"] = this.multiSelect.selectedCategories.length ? this.multiSelect.selectedCategories.map(e => { return e.id }) : [0];
 
        filters.web_filter["brand_ids"] = this.multiSelect.selectedBrands.length ? this.multiSelect.selectedBrands.map(e => { return e.id }) : [0];
 
        this.campSvc.getItems(filters).pipe(
          tap(() => this.loading.item = true),
          finalize(() => {
            this.loading.item = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.item = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.item = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
              this.loading.error = true;
              this.items = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.items[0] = this.defaultOption;
              }
              this.items = this.items.concat(res.data);
              this.checkSelected('items', 'selectedItems', 'item');
          
              if((res.data.length > 0) && (this.items.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }
      
      case "location_region": {
        filters.web_filter["country_ids"] = [0];
 
        this.campSvc.getRegions(filters).pipe(
          tap(() => this.loading.location_region = true),
          finalize(() => {
            this.loading.location_region = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.location_region = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.location_region = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
              this.loading.error = true;
              this.location_regions = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.location_regions[0] = this.defaultOption;
              }
              this.location_regions = this.location_regions.concat(res.data);
              this.checkSelected('location_regions', 'selectedRegions', 'location_region');

              if((res.data.length > 0) && (this.location_regions.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }
      
      case "location_province": {
        filters.web_filter["country_ids"] = [0];

        filters.web_filter["region_ids"] = this.multiSelect.selectedRegions.length ? this.multiSelect.selectedRegions.map(e => { return e.id }) : [0];
 
        this.campSvc.getProvinces(filters).pipe(
          tap(() => this.loading.location_province = true),
          finalize(() => {
            this.loading.location_province = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.location_province = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.location_province = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
              this.loading.error = true;
              this.location_provinces = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.location_provinces[0] = this.defaultOption;
              }
              this.location_provinces = this.location_provinces.concat(res.data);
              this.checkSelected('location_provinces', 'selectedProvinces', 'location_province');

              if((res.data.length > 0) && (this.location_provinces.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }
      
      case "location_city": {
        filters.web_filter["country_ids"] = [0];

        filters.web_filter["region_ids"] = this.multiSelect.selectedRegions.length ? this.multiSelect.selectedRegions.map(e => { return e.id }) : [0];

        filters.web_filter["province_ids"] = this.multiSelect.selectedProvinces.length ? this.multiSelect.selectedProvinces.map(e => { return e.id }) : [0];
 
        this.campSvc.getCities(filters).pipe(
          tap(() => this.loading.location_city = true),
          finalize(() => {
            this.loading.location_city = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.location_city = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.location_city = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
              this.loading.error = true;
              this.location_citys = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.location_citys[0] = this.defaultOption;
              }
              this.location_citys = this.location_citys.concat(res.data);
              this.checkSelected('location_citys', 'selectedCities', 'location_city');
                
              if((res.data.length > 0) && (this.location_citys.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }
      
      case "chain_type": {
        filters.web_filter["city_ids"] = this.multiSelect.selectedCities.length ? this.multiSelect.selectedCities.map(e => { return e.id }) : [0];
 
        this.campSvc.getChaintypes(filters).pipe(
          tap(() => this.loading.chain_type = true),
          finalize(() => {
            this.loading.chain_type = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.chain_type = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.chain_type = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
              this.loading.error = true;
              this.chain_types = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.chain_types[0] = this.defaultOption;
              }
              this.chain_types = this.chain_types.concat(res.data);
              this.checkSelected('chain_types', 'selectedChainTypes', 'chain_type');
            
              if((res.data.length > 0) && (this.chain_types.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }
      
      case "chain": {
        filters.web_filter["chain_type_ids"] = this.multiSelect.selectedChainTypes.length ? this.multiSelect.selectedChainTypes.map(e => { return e.id }) : [0];
 
        this.campSvc.getChains(filters).pipe(
          tap(() => this.loading.chain = true),
          finalize(() => {
            this.loading.chain = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.chain = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.chain = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
              this.loading.error = true;
              this.chains = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.chains[0] = this.defaultOption;
              }
              this.chains = this.chains.concat(res.data);
              this.checkSelected('chains', 'selectedChains', 'chain');
             
              if((res.data.length > 0) && (this.chains.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }
      
      case "branch": {
        filters.web_filter["chain_type_ids"] = this.multiSelect.selectedChainTypes.length ? this.multiSelect.selectedChainTypes.map(e => { return e.id }) : [0];

        filters.web_filter["chain_ids"] = this.multiSelect.selectedChains.length ? this.multiSelect.selectedChains.map(e => { return e.id }) : [0];
        
        filters.web_filter["region_ids"] = this.multiSelect.selectedRegions.length ? this.multiSelect.selectedRegions.map(e => {return e.id}) :[0];
        filters.web_filter["province_ids"] = this.multiSelect.selectedProvinces.length ? this.multiSelect.selectedProvinces.map(e => {return e.id}) :[0];
        filters.web_filter["city_ids"] = this.multiSelect.selectedCities.length ? this.multiSelect.selectedCities.map(e => {return e.id}) :[0];
        this.campSvc.getBranches(filters).pipe(
          tap(() => this.loading.branch = true),
          finalize(() => {
            this.loading.branch = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.branch = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.branch = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
              this.loading.error = true;
              this.branches = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.branches[0] = this.defaultOption;
              }
              this.branches = this.branches.concat(res.data);
              this.checkSelected('branches', 'selectedBranch', 'branch');
          
              if((res.data.length > 0) && (this.branches.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }

      case "web_user": {
        this.campSvc.getWebUserGroup(filters).pipe(
          tap(() => this.loading.web_user = true),
          finalize(() => {
            this.loading.web_user = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.web_user = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.web_user = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
              this.loading.error = true;
              this.web_users = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.web_users[0] = this.defaultOption;
              }
              this.web_users = this.web_users.concat(res.data);
              this.checkSelected('web_users', 'selectedWebUser', 'web_user');
          
              if((res.data.length > 0) && (this.web_users.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }

      case "recipient": {
        filters.web_filter["user_group_ids"] = this.multiSelect.selectedWebUser.length ? this.multiSelect.selectedWebUser.map(e => { return e.id }) : [0];
        this.campSvc.getRecipientGroup(filters).pipe(
          tap(() => this.loading.recipient = true),
          finalize(() => {
            this.loading.recipient = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.recipient = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.recipient = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
              this.loading.error = true;
              this.recipients = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.recipients[0] = this.defaultOption;
              }
              this.recipients = this.recipients.concat(res.data);
              this.checkSelected('recipients', 'selectedRecipient', 'recipient');
          
              if((res.data.length > 0) && (this.recipients.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }
    }
  }
 
  categoryBrandItemToggle(value) {
    if (this.viewMode) {
      return;
    }

    this.multiSelect.selectedCategories = [this.defaultOption];
    this.multiSelect.selectedBrands = [this.defaultOption];
    this.multiSelect.selectedItems = [this.defaultOption];

    this.formGroup.get("category").reset(null, {emitEvent: false});
    this.formGroup.get("brand").reset(null, {emitEvent: false});
    this.formGroup.get("item").reset(null, {emitEvent: false});
 
    this.assignFormValues('selectedCategories', 'category');
    this.assignFormValues('selectedBrands', 'brand');
    this.assignFormValues('selectedItems', 'item');

    switch (_.get(value, 'code')) {
      case "0": {
        this.formGroup.get("category").enable();
        this.formGroup.get("brand").disable();
        this.formGroup.get("item").disable();
        this.formGroup.get("category").statusChanges.subscribe(
          status => {
            if(this.multiSelect.selectedCategories.length && (!this.formGroup.get("category").valid)) {
              this.formGroup.get("category").markAsUntouched();
              return;
            }
            if(this.chipsCategory) {
              this.chipsCategory.errorState = status === 'INVALID'
            }
          }
        );
        break;
      }
 
      case "1": {
        this.formGroup.get("category").disable();
        this.formGroup.get("brand").enable();
        this.formGroup.get("item").disable();
        this.formGroup.get("brand").statusChanges.subscribe(
          status => {
            if(this.multiSelect.selectedBrands.length && (!this.formGroup.get("brand").valid)) {
              this.formGroup.get("brand").markAsUntouched();
              return;
            }
            if(this.chipsBrand) {
              this.chipsBrand.errorState = status === 'INVALID'
            }
          }
        );
        break;
      }
 
      case "2": {
        this.formGroup.get("category").disable();
        this.formGroup.get("brand").disable();
        this.formGroup.get("item").enable();
        this.formGroup.get("item").statusChanges.subscribe(
          status => {
            if(this.multiSelect.selectedItems.length && (!this.formGroup.get("item").valid)) {
              this.formGroup.get("item").markAsUntouched();
              return;
            }
            if(this.chipsItem) {
              this.chipsItem.errorState = status === 'INVALID'
            }
          }
        );
        break;
      }
    }
  }
 
  // activationTypeToggle(value) {
  //   switch (value) {
  //     case "0": {
  //       this.formGroup.get("num_of_txn").reset();
  //       this.formGroup.get("reg_deadline").reset();
  //       this.formGroup.get("reg_deadline").disable();
  //       this.formGroup.get("num_of_txn").disable();
  //       break;
  //     }
 
  //     case "1": {
  //       if(!(_.toLower(this.status) == "ongoing" && this.editMode) && !(_.toLower(this.status) == "pending"  && (this.did_generate == true))) { 
  //         this.formGroup.get("reg_deadline").enable();
  //       }
  //       this.formGroup.get("num_of_txn").reset();
  //       this.formGroup.get("num_of_txn").disable();
  //       break;
  //     }
 
  //     case "2": {
  //       this.formGroup.get("reg_deadline").reset();
  //       this.formGroup.get("reg_deadline").disable();
  //       if(!(_.toLower(this.status) == "ongoing" && this.editMode) && !(_.toLower(this.status) == "pending"  && (this.did_generate == true))) { 
  //         this.formGroup.get("num_of_txn").enable();
  //       }
  //       this.formGroup.get("num_of_txn").setValidators([
  //         Validators.required, 
  //         Validators.pattern(PATTERN_NUMERIC),
  //         Validators.min(0)
  //       ]);
  //       break;
  //     }
  //   }
  // }
 
  expirationTypeToggle(value) {
    if (this.viewMode) {
      return;
    }

    switch (value) {
      case "0": {
        if(((_.toLower(this.status) == "pending" && this.editMode) && !(_.toLower(this.status) == "pending"  && (this.did_generate == true))) || _.toLower(this.status) == "new") {
          this.formGroup.get("exp_date").enable();
          this.formGroup.get("exp_date").setValue(this.formGroup.get("red_end_date").value)
        }
        this.formGroup.get("num_of_days").reset();
        this.formGroup.get("num_of_days").disable();
        this.formGroup.get("num_of_days").markAsPristine();
        this.formGroup.get("num_of_days_from_first_purchase").reset();
        this.formGroup.get("num_of_days_from_first_purchase").disable();
        this.formGroup.get("num_of_days_from_first_purchase").markAsPristine();
        break;
      }
 
      case "1": {
        this.formGroup.get("exp_date").reset();
        this.formGroup.get("exp_date").disable();
        this.formGroup.get("exp_date").markAsPristine();
        this.formGroup.get("num_of_days").reset();
        this.formGroup.get("num_of_days").disable();
        this.formGroup.get("num_of_days").markAsPristine();
        this.formGroup.get("num_of_days_from_first_purchase").reset();
        this.formGroup.get("num_of_days_from_first_purchase").disable();
        this.formGroup.get("num_of_days_from_first_purchase").markAsPristine();
        break;
      }
 
      case "2": {
        this.formGroup.get("exp_date").reset();
        this.formGroup.get("exp_date").disable();
        this.formGroup.get("exp_date").markAsPristine();
        if(!(_.toLower(this.status) == "ongoing" && this.editMode) && !(_.toLower(this.status) == "pending"  && (this.did_generate == true))) { 
          this.formGroup.get("num_of_days").enable();
        }
        this.formGroup.get("num_of_days_from_first_purchase").reset();
        this.formGroup.get("num_of_days_from_first_purchase").disable();
        this.formGroup.get("num_of_days_from_first_purchase").markAsPristine();
        break;
      }
 
      case "3": {
        this.formGroup.get("exp_date").reset();
        this.formGroup.get("exp_date").disable();
        this.formGroup.get("exp_date").markAsPristine();
        this.formGroup.get("num_of_days").reset();
        this.formGroup.get("num_of_days").disable();
        this.formGroup.get("num_of_days").markAsPristine();
        if(!(_.toLower(this.status) == "ongoing" && this.editMode) && !(_.toLower(this.status) == "pending"  && (this.did_generate == true))) {
          this.formGroup.get("num_of_days_from_first_purchase").enable();
        }
        break;
      }
    }
  }
 
  checkSelected(srcArray, targetArray, formControlName) {
    if(this.multiSelect[targetArray].some(opt => opt.description == 'All')) {
      let tempObj = _.cloneDeep(this.defaultOption);
      tempObj.selected = false;
      this.toggleSelection(tempObj, this[srcArray], targetArray, formControlName, null);
    } 
    else if (this.multiSelect[targetArray].length) {
      this[srcArray].forEach(e => {
        this.multiSelect[targetArray].forEach(v => {
          if(e.description == v.description) {
            e.selected = v.selected;
          }
        })
        if(e.description == 'All') {
          e.selected = false;
        }
      })
    } else {
      this[srcArray].forEach(e => {
        e.selected = false;
      })
    }
  }
 
  optionClicked(event: Event, data, srcArray, targetArray, formControlName, inputElem) {
    event.stopPropagation();
    this.toggleSelection(data, srcArray, targetArray, formControlName, inputElem);
  }
 
  toggleSelection(data, srcArray, targetArray, formControlName, inputElem) {
    // Clear inputted text in field
    if(inputElem) {
      inputElem.value = '';
    }

    // Clear recipients if web_user was changed
    if(formControlName == 'web_user') {
      if (_.toLower(this.status) != 'ongoing' && this.did_generate != 1) {
        this.clearFormControl('recipient', 'selectedRecipient');
      } else {
        this.multiSelect.selectedRecipient = _.cloneDeep(this.savedMultiSelect.selectedRecipient)
        this.formGroup.controls['recipient'].setValue(this.savedMultiSelect.selectedRecipient, { emitEvent: false });
      }
    }

    if(formControlName == 'location_region') {
      this.clearOtherLocations();
    }

    data.selected = !data.selected;
 
    //if 'all' is selected, choose only all
    if(data.selected == true && data.code == 'all') {
      srcArray.forEach(e => {
        e.selected = true;
      });
      this.multiSelect[targetArray] = [];
      this.multiSelect[targetArray].push(data);
      this.disableCheckbox(srcArray, formControlName, data);
    } 
 
    //if 'all' is deselected, unselect everything
    else if(data.selected == false && data.code == 'all') {
      srcArray.forEach(e => {
        e.selected = false;
      });
      this.multiSelect[targetArray].splice(this.multiSelect[targetArray].indexOf(data), 1);
      this.enableCheckbox(srcArray);
    } 
 
    else if(this.multiSelect[targetArray].indexOf(data) == -1) {
      //if other option is selected, check if 'all' is already selected and clear selection
      // this.multiSelect[targetArray].some(opt => opt.code == data.code)
      if(this.multiSelect[targetArray].indexOf(this.defaultOption) > -1) {
        srcArray.forEach(e => {
          e.selected = false;
        });
        this.multiSelect[targetArray] = [];
      } 
      //if data exists in array, remove from list
      else if(this.multiSelect[targetArray].some(opt => opt.code == data.code)) {
        let index = _.findIndex(this.multiSelect[targetArray], function(item) { return item['code'] == data.code })
        this.multiSelect[targetArray].splice(index, 1);
      } 
      else {
        this.multiSelect[targetArray].push(data);
      }
    } 
    
    else {
      this.multiSelect[targetArray].splice(this.multiSelect[targetArray].indexOf(data), 1);
      srcArray.forEach(e => {
        if(e.id == data.id) {
          e.selected = false;
        }
      });
    }
  
    this.assignFormValues(targetArray, formControlName);
  }
 
  enableCheckbox(optionArray) {
    optionArray.forEach(e => {
      e.disabled = false;
    })
  }
 
  disableCheckbox(optionArray, formControlName, data) {
    if (optionArray[0].selected && (_.has(this.formGroup.get(formControlName), 'value') && this.formGroup.get(formControlName).value == 0) || (_.get(data, 'code') == 'all')) {
      optionArray.forEach(e => {
        if(e.code != 'all') {
          e.disabled = true;
        }
      })
    } else {
      this.enableCheckbox(optionArray);
    }
  }
 
  assignFormValues(targetArray, formControlName) {
    let tempArr;
    if((formControlName != 'location_region') && (formControlName != 'location_province') && (formControlName != 'location_city')) {
      tempArr = this.multiSelect[targetArray].map(e => {
        return e.id;
      });
    } else {
      tempArr = this.multiSelect[targetArray].map(e => {
        //kapag location region, province and city - eto ang expected format ng object
        let obj = {
          code: e.code,
          description: e.description
        }
        return obj;
      });
    }
    this.formGroup.get(formControlName).setValue(tempArr);
  }
 
  autoCmpltClosed(name) {
    let options = (name != 'branch') ? (name + "s") : (name + "es");
    this[options] = [];
  }
 
  resetControl(control: FormControl) {
    control.reset(null);
  }
 
  displayFn(data?: any): string | undefined {
    return _.get(data, 'description');
  }

  autocompleteScroll(name, refName, acTrigger) {
    setTimeout(() => {
      if (this[refName].isOpen || this[refName].panel) {
        fromEvent(this[refName].panel.nativeElement, 'scroll')
          .pipe(
            map(x => this[refName].panel.nativeElement.scrollTop),
            takeUntil(this[acTrigger].panelClosingActions)
          )
          .subscribe(x => {
            const scrollTop = this[refName].panel.nativeElement
              .scrollTop;
            const scrollHeight = this[refName].panel.nativeElement
              .scrollHeight;
            const elementHeight = this[refName].panel.nativeElement
              .clientHeight;
            const atBottom = scrollHeight === scrollTop + elementHeight;
            if (atBottom) {
              // fetch more data
              this.getMoreData(name);
            }
          });
      }
    });
  }

  clearOtherLocations() {
    this.multiSelect.selectedProvinces = [];
    this.formGroup.get('location_province').reset(null, {emitEvent: false});
    this.multiSelect.selectedCities = [];
    this.formGroup.get('location_city').reset(null, {emitEvent: false});
  }

  clearFormControl(formControlName, multiSelectName) {
    this.multiSelect[multiSelectName] = [];
    console.log(this.formGroup.controls[formControlName].value)

    this.formGroup.controls[formControlName].reset(null, {emitEvent: false});

    console.log(this.formGroup.controls[formControlName].value)

    this.formGroup.controls[formControlName].markAsUntouched();
    this.formGroup.controls[formControlName].setValue(this.multiSelect[multiSelectName], { emitEvent: false });
  }

  checkAutocompleteObject(control, objectKey, targetArray) {
    if ((!_.isObject(control.controls[objectKey].value) || control.controls[objectKey].value.id == null) && control.controls[objectKey].value != "") {
      control.controls[objectKey].setErrors({
        "notExisting": true
      });
    }

    if(_.size(this.multiSelect[targetArray]) && targetArray) {
      control.controls[objectKey].setValue(null);
      this.assignFormValues(targetArray, objectKey);
    }

    // If no selections were made and no typed text
    if (!_.size(this.multiSelect[targetArray]) && control.controls[objectKey].value == "") {
      control.controls[objectKey].setErrors({
        "required": true
      });
    }

    //tinagal ni ace - kasi nawawala yung choices pag pumili, paki balik nlng po kng needed pero paki check issue 286 after ibalik
    //this.autoCmpltClosed(objectKey);
  }
}
 
const INITIAL_OPTIONS = {
	web_filter: {
		limit: 50,
		offset: 0,
    keyword: "",
    status: null,
    order_by: "asc",
		is_asc: 1
	}
}
